export default "__VITE_ASSET__CmJ3X60v__"